<template>
<div class="paddingh30 paddingt30 pos-r bg-white">
    <a :href="calendarAdPoster.items[0].clickUrl" :data-scp="$options.name+'.00'">
    <!-- <div v-show="calendarAdPoster.items">
        <img src="http://image1.51tiangou.com/tgou2/img2/discover/banner_discover_01.png" width="100%">
    </div> -->
    <img :src="calendarAdPoster.items[0].imageUrl" alt="" width="100%">
    <!-- 日历组件 -->
    <!-- <div class="pos-a activeDate top30 right50 bg-white">
        <div style="border:1px solid #bedec9">
            <div class="activeDateTitle text-center fs-12">
                活动日历
            </div>
            <div class="flex-container center dateList pos-r">
                <div v-for="(index,item) in testData" class="text-center flex1 flex-container center" style="height:14px;">
                    <span class="dateSelect border-round dis-i" :class="defaultActiveDate == index && 'active'" v-text="item" @click="defaultActiveDate = index"></span>
                </div>
            </div>
        </div>
    </div> -->
    </a>
    
</div>
</template>

<script>
import _ from '_';
import $ from 'jquery';
export default {
    props:{
        data:{
            type: Object,
            default: function () {
                return {
                    items: [
                            {
                                clickUrl: "//m.dev.66buy.com.cn/chengshihui/huodongrili.html",
                                imageUrl: "//test.img.tg-img.com/123!y"
                            }
                    ],
                    serverTime: 1492070563141
                }
            }
        } 
    },
    computed:{
        calendarAdPoster:function(){
            return this.data;
        }
    },
    ready:function(){

    },
    methods:{

    }
}
</script>

<style lang="scss">
.activeDate{
    width:64px;
    padding:4px;
    box-shadow: 4px 4px 0 rgba(0,0,0,.2);
}
.activeDateTitle{
    color:#bedec9;
    padding:5px 0;
    line-height: normal;
}
.dateSelect{
    width:14px;
    height:14px;
    line-height:14px;
    background:#f7f8f7;
    color:#e3e3e3;
    font-size:8px;
}
.dateSelect.active{
    background:#badac5;
    color:#fff;
}
.dateList{
    padding:5px 0;
}
.dateList:after{
    content:'';
    position: absolute;
    top:0;
    left:10%;
    height:1px;
    width:80%;
    background-color: #e2ece6;
}
</style>